export default "__VITE_ASSET__d19c4321__"